// extracted by css-extract-rspack-plugin
export default {"checkRunStatusContainer":"CheckRunStatus-module__checkRunStatusContainer__oCBNoFI"};